module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_warehouse_items_title')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_from')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_from'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_to')) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": _vm.locale.t('label_to'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search')
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_picture')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_name')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_created_by')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_date')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_stock_number')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_note')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(item.image != null && item.image.length > 0) ? _c('img', {
      staticClass: "cropped1 user-avatar-sm",
      attrs: {
        "src": item.image
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_created_by')
      }
    }, [_vm._v(_vm._s(item.createdBy))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_date')
      }
    }, [_vm._v(_vm._s(_vm.formatDateAndTime(item.timestamp)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_stock_number')
      }
    }, [_vm._v(_vm._s(item.stockNumber))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_note')
      }
    }, [_vm._v(_vm._s(item.note && item.note.length > 0 ? item.note : '-'))])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1976156!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Warehouse/WarehouseShopItem.vue
// module id = 836
// module chunks = 0